import { render, staticRenderFns } from "./ButtonFriend.vue?vue&type=template&id=456d52ba&"
import script from "./ButtonFriend.vue?vue&type=script&lang=js&"
export * from "./ButtonFriend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports